export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-3-960-4444b8d4ed6ec5d649201c650fee38d4.webp";